module.exports = __webpack_public_path__ + "images/emoji/black_medium_small_square.b3231d2c97013b56cdba.png";